
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attribution-instructions",
      function () {
        return require("private-next-pages/attribution-instructions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attribution-instructions"])
      });
    }
  